import { SailsStoneDdpStorage } from 'Container/App/interface';
import {
    getSessionStorageItemJson,
    SAILS_PARAM_PAYMENT_METHOD,
} from '@vfde-sails/storage';
import { SAILS_MULTICARD_STORAGE } from '@vfde-sails/constants';
import { PriceType } from '@vfde-sails/glados-v2';

/**
 * Get payment method
 */
export const getPaymentMethod = (storage?: SailsStoneDdpStorage | null): PriceType | undefined => {
    storage = storage || getSessionStorageItemJson<SailsStoneDdpStorage | null>(SAILS_MULTICARD_STORAGE);

    return storage?.[SAILS_PARAM_PAYMENT_METHOD];
};
